module.exports = __webpack_public_path__ + "img/monitoring.75b5a218.png";